import config from 'config'
import { selectSkipRefetchChannelsList } from 'data/selectors'
import type { GetDateKeyOptions } from 'data/types'
import { getRequestParams } from 'data/utils'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import { fetchAction } from 'utils'

import * as constants from './constants'

const fetchChannels = createLogic<State, GetDateKeyOptions>({
  type: constants.FETCH_CHANNELS,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchChannelsList(action.payload)(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_CHANNELS_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.channels, {
          ...baseRequestParams,
          ...getRequestParams(action as any),
        })

        dispatch({
          type: constants.FETCH_CHANNELS_SUCCESS,
          payload: {
            ...action.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        type: constants.FETCH_CHANNELS_ERROR,
        payload: action.payload,
      })
    }
    done()
  },
})

export default [fetchChannels]
